import React, {useContext} from 'react';
import {Button, Descriptions, Popconfirm, Table, Tag} from 'antd';
import dayjs from 'dayjs';
import {PlayerContext} from '../../../../shared/contexts/playerContext';
import IsLoading from '../../../../shared/components/IsLoading';
import ErrorPage from '../../../../shared/components/ErrorPage';
import {useGetProsperityInfo, useResendProsperityReward} from '../../usePlayerData';

const formatRewards = (rewards) => (rewards || []).map(r => `${r.name}(${r.id}) ${r.quantity}개`).join(', ');

const Prosperity = () => {
    const {playerData} = useContext(PlayerContext);
    const {data, isLoading, error} = useGetProsperityInfo({userKey: playerData.userKey});
    const resendMutation = useResendProsperityReward();

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const {status, rewardHistory} = data || {};

    const columns = [
        {
            title: '달성 등급',
            key: 'grade',
            width: 160,
            render: (_, row) => `${row.grade} (${row.gradeName})`,
        },
        {
            title: '달성 시각 (KST)',
            key: 'achievedAt',
            width: 180,
            render: (_, row) => row.isReceived
                ? (row.achievedAt ? dayjs(row.achievedAt).format('YYYY-MM-DD HH:mm:ss') : '-')
                : <Tag color="orange">미수령</Tag>,
        },
        {
            title: '획득 보상',
            key: 'rewards',
            render: (_, row) => formatRewards(row.rewards),
        },
        {
            title: '처리',
            key: 'action',
            width: 100,
            render: (_, row) => (
                <Popconfirm
                    title={`${row.grade}등급 보상을 재지급하시겠습니까?`}
                    onConfirm={() => resendMutation.mutate({userKey: playerData.userKey, grade: row.grade})}
                    okText="확인"
                    cancelText="취소"
                >
                    <Button size="small" danger={!row.isReceived} loading={resendMutation.isPending}>재지급</Button>
                </Popconfirm>
            ),
        },
    ];

    return (
        <div style={{padding: '0 8px'}}>
            <div style={{marginBottom: 8, fontWeight: 600}}>번영도 상태</div>
            <Descriptions bordered size="small" column={2} style={{marginBottom: 24}}>
                <Descriptions.Item label="번영도 등급">{status ? `${status.townLevel} (${status.townLevelName})` : '-'}</Descriptions.Item>
                <Descriptions.Item label="번영도 점수">{status?.prosperityPoint?.toLocaleString() ?? '-'}</Descriptions.Item>
                <Descriptions.Item label="골드 생산량">
                    {status ? `${status.goldProduction.total.toLocaleString()} / h (+${status.goldProduction.buff.toLocaleString()})` : '-'}
                </Descriptions.Item>
                <Descriptions.Item label="에너지 최대치">
                    {status ? `${status.energyMax.total.toLocaleString()} (+${status.energyMax.buff.toLocaleString()})` : '-'}
                </Descriptions.Item>
            </Descriptions>

            <div style={{marginBottom: 8, fontWeight: 600}}>보상 수령 내역</div>
            <Table
                size="small"
                dataSource={(rewardHistory || []).map(r => ({...r, key: r.grade}))}
                columns={columns}
                pagination={false}
                bordered
            />
        </div>
    );
};

export default Prosperity;
